<template>
    <div class="picture">
        <ProfilePictureBackground :color="color"/>
        <img v-bind="$attrs"/>
    </div>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'ProfilePicture',
    mixins: [Colorable],
    inheritAttrs: false,
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

.picture {
    position: relative;
    display: inline-block;
    border-radius: 50%;

    > svg {
        display: block;
    }

    > img {
        position: absolute;
        box-sizing: initial;
        left: 50%;
        top: 50%;
        width: 100px;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        box-shadow: 0 6px 6px 0 rgba($black, .05);
    }
}
</style>
